import React from "react";
import { AboutListContainer } from "./AboutListElements";
import { AboutArticle } from "../AboutItem";

const AboutList = () => {
  return (
    <AboutListContainer>
      <AboutArticle />
    </AboutListContainer>
  );
};

export default AboutList;
